import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-53d49005")

_pushScopeId("data-v-53d49005")
const _hoisted_1 = {
  class: "dropdown",
  ref: "dropdownList"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "dropdown-slot" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.dropdownItems)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dropdownItems, (item, i) => {
            return (_openBlock(), _createBlock("div", {
              key: i,
              class: {
                    'dropdown-item': true,
                    selected: item === _ctx.selectedAlgo,
                },
              onClick: ($event: any) => (_ctx.emitAndHide(item))
            }, _toDisplayString(item), 11, ["onClick"]))
          }), 128))
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ])
        ]))
  ], 512))
})